<template lang="pug">
  v-container.fill-height.align-start.flex-column(fluid v-resize="onResize")
    v-snackbar(v-model="showSnackBar" :color="snackBarColor") {{ snackBarMessage }}
      template(v-slot:action="{ attrs }")
        v-btn.justify-end(fab text v-bind="attrs" @click="showSnackBar = false")
          v-icon fal fa-times-circle
    AddNewTransactionDialog(
      v-if="showAddNewTransactionDialog"
      :show="showAddNewTransactionDialog"
      @close="onAddNewTransactionDialogClose"
      @openResolveDialog="openResolveDialog"
      @complete="onCompleteTransaction")
    ResolveTransactionDialog(
      v-if="showResolveDialog"
      :show="showResolveDialog"
      @close="onResolveTransactionDialogClose"
      :currentSelection="currentSelection"
      )
    ImportTransactionDialog(
      v-if="showImportDialog"
      :show="showImportDialog"
      @close="closeImportDialog"
      @resolve="resolveDialog"
      @open="openControlImportTransactionDialog")
    TransactionDetailDialog(
      v-if="showTransactionDetailDialog"
      :show="showTransactionDetailDialog"
      :transactionDetail="transactionDetail"
      @closeDetailDialog="closeDetailDialog"
      @resolve="resolveDialogOpen"
    )
    v-container(style="padding: 12px 0" )
      v-card-title(style="padding: 25px 0") {{ $t('drawerPage.bankTransferLabel') }}
      v-toolbar(dense flat)
        v-btn.transaction.mr-1( @click="onAddNewTransaction")
          v-icon(small left) fas fa-plus
          span.ma-2 {{ $t('bankTransactionPage.newTransaction') }}
        v-btn.ml-1.mr-1(  color="primary" @click="onImportTransaction")
          v-icon(small) fas fa-file-import
          span.ma-2 Import
        v-btn.ml-1(  @click="onResolveTransaction" :disabled="isResolveButtonDisabled")
          v-icon fas fa-question-circle
          span.ma-2 {{ $t('bankTransactionPage.resolveButtonLabel') }} {{ selectionCount }}
        v-spacer
        v-btn-toggle()
          v-btn.mr-2( @click="onToResolveTransaction" ) {{ $t('bankTransactionPage.toResolveFilterLabel') }}
        v-divider(vertical)
        v-card.ml-2
        v-btn-toggle(v-if="$vuetify.breakpoint.width > 1305"  v-model="selectedFilterButton")
          v-btn( @click="onSelectedFilter(item)"  v-for="(item,idx) in timeFiltersList" :key="idx")
            span {{item.label}}
        v-menu(v-if="$vuetify.breakpoint.width < 1305")
          template(v-slot:activator="{ on, attrs }" )
            v-btn.mb-0( filled outlined  height="46" large v-bind="attrs" v-on="on") {{selectedFilter ? selectedFilter.label : "Filter"}}
              v-icon.pb-2(small right ) fas fa-sort-down
          v-list()
            v-list-item( v-for="(item, idx) in timeFiltersList" :key="idx" @click="onSelectedFilter(item)")
              v-list-item-title {{item.label}}

      v-toolbar.mt-2(dense flat)
        v-row.ma-0
          v-spacer
          v-form(ref="form" v-model="isFormValid" :disabled="fetchInProgress")
            v-row.ma-0(align="center")
              v-menu(ref="menuFrom"
                v-model="menuFrom"
                :close-on-content-click="false"
                :return-value.sync="dateFrom"
                transition="scale-transition"
                offset-y
                min-width="auto"
                )
                template( v-slot:activator="{ on, attrs }")
                  v-text-field.date-picker.mr-3(v-model="formattedDateFrom" dense
                    outlined
                    :label=" $t('billingPage.dateFromFilterShort') "
                    prepend-inner-icon="fas fa-calendar-alt"
                    @click:prepend-inner="menuFrom=true"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="clearDateFrom"
                    hide-details
                    clearable
                    clear-icon="fal fa-times"
                    :rules="dateRules")
                v-date-picker(v-model="dateFrom"
                  @change="saveFrom(dateFrom)"
                  no-title
                  :min="minAllowedDate"
                  :max="maxAllowedDate"
                  first-day-of-week="1"
                  show-week
                  prev-icon="fas fa-chevron-left"
                  next-icon="fas fa-chevron-right")
                  v-spacer
                  v-btn(text
                  color="primary"
                    @click="menuFrom = false") {{ $t('buttons.cancelButtonLabel') }}
              v-menu(ref="menuTo"
                v-model="menuTo"
                :close-on-content-click="false"
                :return-value.sync="dateTo"
                transition="scale-transition"
                offset-y
                min-width="auto"
                )
                template( v-slot:activator="{ on, attrs }")
                  v-text-field.date-picker.mr-3(v-model="formattedDateTo" dense
                    outlined
                    :label=" $t('billingPage.dateToFilterShort') "
                    prepend-inner-icon="fas fa-calendar-alt"
                    @click:prepend-inner="menuTo=true"
                    readonly
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="clearDateTo"
                    clearable
                    clear-icon="fal fa-times"
                    :rules="dateRules")
                v-date-picker(v-model="dateTo"
                  @change="saveTo(dateTo)"
                  no-title
                  :min="minAllowedDate"
                  :max="maxAllowedDate"
                  first-day-of-week="1"
                  show-week
                  prev-icon="fas fa-chevron-left"
                  next-icon="fas fa-chevron-right")
                  v-spacer
                  v-btn(text
                  color="primary"
                  @click="menuTo = false") {{ $t('buttons.cancelButtonLabel') }}
              v-btn( color="primary" @click="onDatesFilterConfirmClick" :disabled="!isFormValid" :loading="fetchInProgress" ) {{ $t('buttons.confirmDatesFilterButtonLabel')}}
    v-container.pa-0.flex-shrink-0.flex-grow-1
      AgGridVue.mt-2.ag-theme-balham(
        style="width: 100%; height: 100%; min-height: 500px"
        :gridOptions="gridOptions"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :pinnedBottomRowData="pinnedRowData"
        :localeTextFunc="localeTextFunc"
        @grid-ready="onGridReady"
        @selection-changed="onSelectionChange"
        @row-double-clicked="onDetailTransaction"
        @rowDataChanged="onRowDataChanged"
        :frameworkComponents="gridFrameworkComponents"
      )

</template>

<script lang="ts">
import Vue from 'vue'
import moment from "moment";
import i18n from '@/i18n'
import 'ag-grid-enterprise'
import {AgGridVue} from 'ag-grid-vue'
import {
  ColDef, ColumnApi, GridApi,
  GridOptions, ICellRendererParams,
  RowNode,
  ValueFormatterParams, ValueGetterParams,
} from 'ag-grid-community'
import {Component, Ref} from "vue-property-decorator";
import AddNewTransactionDialog from "@/components/AddNewTransactionDialog.vue";
import {Action} from "vuex-class";
import {FETCH_BANK_TRANSACTION_DETAIL, FETCH_BANK_TRANSACTION_LIST} from "@/store/action-types";
import BankTransaction from "@/model/BankTransaction/BankTransaction";
import ResolveTransactionDialog from "@/components/user/ResolveTransactionDialog.vue";
import ImportTransactionDialog from "@/components/ImportTransactionDialog.vue";
import BankTransactionStatusCellRenderer from "@/components/user/BankTransactionStatusCellRenderer.vue";
import {
  BankTransactionListPayload,
  BankTransactionListPayloadWithCancelToken,
  FilterBillingsPayload
} from "@/types/payload";
import axios, {CancelTokenSource} from "axios";
import BankTransactionImport from "@/model/BankTransactionImport";
import TransactionDetailDialog from "@/components/user/TransactionDetailDialog.vue";
import {BankTransactionFilters} from "@/types/service-response";
import BankTransactionCustomStatusPanel from "@/components/user/BankTransactionCustomStatusPanel.vue";
import {MonthFilter} from "@/types";

@Component({
  components: {
    AddNewTransactionDialog,
    AgGridVue,
    ResolveTransactionDialog,
    ImportTransactionDialog,
    BankTransactionStatusCellRenderer,
    TransactionDetailDialog,
    BankTransactionCustomStatusPanel,
  }
})
export default class BankTransferPage extends Vue {

  $refs!: {
    menuFrom: Vue & {
      save(date: string): void,
    },
    menuTo: Vue & {
      save(date: string): void,
    },

    form: Vue & {
      validate(): boolean
      resetValidation(): boolean
    }

  }

  @Action(FETCH_BANK_TRANSACTION_LIST) fetchBankTransactionList!: { (payload: BankTransactionListPayloadWithCancelToken | null): Promise<BankTransaction[]> }
  @Action(FETCH_BANK_TRANSACTION_DETAIL) fetchBankTransactionDetail!: { (payload: number): Promise<BankTransaction[]> }
  @Ref('form') readonly form!: Vue & { validate(): boolean }

  private showAddNewTransactionDialog: boolean = false
  private isFormValid: boolean = false
  private gridOptions: GridOptions = {}
  private columnDefs: ColDef[] = []
  private bankTransactionData: BankTransaction[] = []
  private rowData: BankTransaction[] = []
  private currentSelection: BankTransaction[] = []
  private showResolveDialog: boolean = false
  private showImportDialog:boolean = false
  private showControlImportDialog: boolean = false
  private gridFrameworkComponents: Object = {bankTransactionStatusCellRenderer: BankTransactionStatusCellRenderer}
  private cancelToken: CancelTokenSource | null = null
  private gridApi:GridApi | null = null
  private columnApi: ColumnApi | null = null
  private timeFiltersList: BankTransactionFilters[] = [
    {id:1, label: '24h'},
    {id:2, label: i18n.t('bankTransactionPage.week').toString()},
    {id:3, label: i18n.t('bankTransactionPage.month').toString()},
  ]
  private selectedFilter: BankTransactionFilters | null = null
  private isResolveFilterActive: boolean = false
  private importedTransactions: number[] = []
  private showTransactionDetailDialog: boolean = false
  private transactionDetail: BankTransaction | null = null
  private selectedFilterButton: number = 1
  private dateBefore: Date | null = null
  private pinnedRowData: any[] = []
  private localeTextFunc: Function | null = null
  private dateFrom: string = ''
  private dateTo: string = ''
  private menuFrom: boolean = false
  private menuTo: boolean = false
  private formattedDateFrom: string = ''
  private formattedDateTo: string = ''
  private minAllowedDate: string = moment([2020, 8]).startOf('month').format('YYYY-MM-DD')
  private maxAllowedDate: string = moment().add(1, 'month').endOf('month').format('YYYY-MM-DD')
  private month: MonthFilter | null = null
  private months: MonthFilter[] = []
  private dateRules: Array<(v: string) => string | boolean> = [
    (v: string) => !!v || i18n.t('validation.valueIsRequired').toString(),
  ]
  private fetchInProgress: boolean = false
  private showSnackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: string = ''

  createColDefs(): ColDef[] {
    let hideDetails = false

    if (
        screen.orientation.type.includes('portrait')
        && ['xs', 'sm'].includes(this.$vuetify.breakpoint.name as string)
    ) {
      hideDetails = true
    }

    return [
      {
        width: 50,
        cellStyle: {display: 'flex', 'justify-content': 'center'},
        headerName: '',
        suppressMenu: hideDetails,
        field: 'transaction.status',
        filter: false,
        cellRenderer: "bankTransactionStatusCellRenderer",
      },
      {
        width: 130,
        field: 'transaction.createdAt',
        headerName: this.$t('bankTransactionPage.dateColumnLabel').toString(),
        filter: false,
        valueFormatter(params: ValueFormatterParams): string {
          return params.data.transaction.createdAt ? moment(params.data.transaction.createdAt).format('D.M.YYYY') : ''
        }
      },
      {
        flex: 1,
        minWidth: 221,
        headerName: this.$t('bankTransactionPage.nameColumnLabel').toString(),
        field: 'boarder',
        filterParams: {
          debounceMs: 250,
          textCustomComparator: (filter: string, value: string, filterText: string) => {
            const filterTextNormalizeLowerCase = filterText.normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '').toLowerCase();
            const valueNormalizeLowerCase = value.toString().normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '').toLowerCase();


            switch (filter) {
              case 'contains':
                let passed = true
                filterTextNormalizeLowerCase.split(' ').forEach((filterWord: string) => {
                  if (valueNormalizeLowerCase.indexOf(filterWord) < 0) {
                    passed = false;
                  }
                })
                return passed;
              default:
                return false;
            }
          }
        },
        valueGetter(params: ValueGetterParams): string {
          return params.data.boarder ? `${params.data.boarder.person.familyName} ${params.data.boarder.person.firstName}` : ''
        }
      },
      {
        width: 90,
        headerName: this.$t('bankTransactionPage.amountColumnLabel').toString() + ' ' + '€',
        cellStyle: {'text-align': 'right'},
        suppressMenu: hideDetails,
        filter:false,
        field: 'transaction.amount',
        valueFormatter(params: ValueFormatterParams): string {
            let amount = params.data.transaction.amount/ 100
            return parseFloat(amount.toString()).toFixed(2).replace('.', ',') + ' €'
        }
      },
      {
        width: 140,
        headerName: this.$t('bankTransactionPage.variableSymbolColumnLabel').toString(),
        suppressMenu: hideDetails,
        field: 'transaction.variableSymbol',
        valueFormatter(params: ValueFormatterParams): string {
          return params.data.transaction.variableSymbol.toString().replace(/\B(?=(\d{4})+(?!\d))/g, ' ')
        }
      },
      {
        width: 110,
        headerName: this.$t('bankTransactionPage.specificSymbolColumnLabel').toString(),
        suppressMenu: hideDetails,
        field: 'transaction.specificSymbol',
        valueFormatter(params: ValueFormatterParams): string {
          return params.data.transaction.specificSymbol === 0 ? '-' : params.data.transaction.specificSymbol
        }
      },
      {
        width: 290,
        headerName: this.$t('bankTransactionPage.fromIbanColumnLabel').toString(),
        suppressMenu: hideDetails,
        field: 'transaction.fromIban',
        valueFormatter(params: ValueFormatterParams): string {
          return params.data.transaction.fromIban.replace(/\S{4}(?=.)/g, '$& ')
        }
      },
      {
        width: 230,
        cellStyle: {display: 'flex', 'justify-content': 'start'},
        headerName: this.$t('bankTransactionPage.descriptionColumnLabel').toString(),
        suppressMenu: hideDetails,
        field: 'transaction.name',
        valueFormatter(params: ValueFormatterParams): string {
          return params.data.transaction.name === 'not-provided' ? '-' : params.data.transaction.name
        }
      },
    ]
  }

  saveFrom(date: string): void {
    this.$refs.menuFrom.save(date)
    this.getFormattedDateFrom(date)
  }

  saveTo(date: string): void {
    this.$refs.menuTo.save(date)
    this.getFormattedDateTo(date)
  }

  getFormattedDateFrom(date?: string): string {
    if (date) {
      return this.formattedDateFrom = moment(date).format('D.M.YYYY')
    } else {
      return this.formattedDateFrom = moment(this.dateFrom).format('D.M.YYYY')
    }
  }

  getFormattedDateTo(date?: string): string {
    if (date) {
      return this.formattedDateTo = moment(date).format('D.M.YYYY')
    } else {
      return this.formattedDateTo = moment(this.dateTo).format('D.M.YYYY')
    }
  }

  onDatesFilterConfirmClick(): void {
    this.month = null
    if (this.dateFrom && this.dateTo) {
      if (Date.parse(this.dateFrom) < Date.parse(this.dateTo)) {
        let payload: BankTransactionListPayload = {
          dateAfter: moment(this.dateFrom).toDate(),
          dateBefore: moment(this.dateTo).toDate(),
          status: null
        }
        this.fetchData(payload)
      }
    } else {

    }
  }

  onGridReady(params: ICellRendererParams) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
  }

  onRowDataChanged (): void {
    if(this.importedTransactions.length > 0) {
      this.onFlashImportRows()
    }
  }

  get isResolveButtonDisabled(): boolean {
    return this.currentSelection.length === 0
  }

  get selectionCount(): string {
    const count = this.currentSelection.length

    if (count > 0 && this.currentSelection ) {
      return `(${count})`
    }

    return ''
  }

  onResize() {
    if(this.gridApi) {
      this.gridApi.sizeColumnsToFit()
    }
  }

  onSelectedFilter(item: BankTransactionFilters) {
    this.selectedFilter = item
    if(item.id){
      switch (item.id) {
        case 1:
          this.selectedFilterButton = 0
          this.dayTransactionFilter()
          break
        case 2:
          this.selectedFilterButton = 1
          this.weekTransactionFilter()
          break
        case 3:
          this.selectedFilterButton = 2
          this.monthTransactionFilter()
          break
      }
    }
  }


  onToResolveTransaction () {
    this.$refs.form.resetValidation()
    this.isResolveFilterActive = !this.isResolveFilterActive
    if(this.isResolveFilterActive) {
      this.rowData = this.rowData.filter((item: BankTransaction) => item.transaction.status === 'not_processed')
    } else {
      this.rowData = this.bankTransactionData
    }
  }

  openResolveDialog (newTransaction: BankTransaction) {
    this.$refs.form.resetValidation()
    this.onAddNewTransactionDialogClose()
    this.currentSelection.push(BankTransaction.createFromResponse(newTransaction))
    this.showResolveDialog = true
  }

  resolveDialogOpen() {
    this.$refs.form.resetValidation()
    this.showTransactionDetailDialog = false
    this.showResolveDialog = true
  }

  dayTransactionFilter () {
    this.selectedFilter = this.timeFiltersList[0]
    this.$refs.form.resetValidation()
    this.dateBefore = moment().subtract(1, 'days').toDate()
    this.fetchData()
  }

  weekTransactionFilter () {
    this.selectedFilter = this.timeFiltersList[1]
    this.$refs.form.resetValidation()
    this.dateBefore = moment().subtract(1, 'weeks').toDate()
    this.fetchData()
  }

  monthTransactionFilter () {
    this.selectedFilter = this.timeFiltersList[2]
    this.$refs.form.resetValidation()
    this.dateBefore = moment().subtract(1, 'months').toDate()
    this.fetchData()

  }

  onAddNewTransaction () {
    this.showAddNewTransactionDialog = true
  }

  onImportTransaction () {
    this.showImportDialog = true
  }

  closeImportDialog (importedTransactionsData: number[]) {
    this.showImportDialog = false
    if(importedTransactionsData.length > 0) {
      this.importedTransactions = importedTransactionsData
      this.fetchData()
    }
  }

  openControlImportTransactionDialog () {
    this.showControlImportDialog = true
  }

  onResolveTransaction () {
    this.$refs.form.resetValidation()
    this.showResolveDialog = true
  }

  clearDateFrom() {
    this.$refs.form.resetValidation()
    this.dateFrom = ''
  }

  clearDateTo() {
    this.$refs.form.resetValidation()
    this.dateTo = ''
  }

  onResolveTransactionDialogClose (completedTransactions: number[]) {
    this.showResolveDialog = false
    this.showImportDialog = false
    if(completedTransactions.length > 0) {
      this.importedTransactions = completedTransactions
      this.fetchData()
      this.currentSelection = []
    }
  }

  onFlashImportRows (): void {
    let foundTransactionsIndexList: number[] = []
    this.importedTransactions.forEach((item: number) => {
      const foundTransaction: BankTransaction | undefined = this.rowData.find((i: BankTransaction) => i.transaction.id === item)
      if(foundTransaction) {
        const index: number = this.rowData.indexOf(foundTransaction)
        foundTransactionsIndexList.push(index)
      }
    })
    this.importedTransactions = []

    this.onFlashRows(foundTransactionsIndexList)
  }

 resolveDialog (importedTransaction: BankTransactionImport): void {
   this.currentSelection = importedTransaction.transactions.filter((item: BankTransaction) => item.transaction.status === 'not_processed')

   this.showResolveDialog = true
 }

  onSelectionChange(params: GridOptions): void {
    const filteredSelectedTransaction: BankTransaction[] = []
    params.api!.getSelectedRows().forEach((item: BankTransaction) => {
      if(item && item.transaction.status === 'not_processed') {
        filteredSelectedTransaction.push(item)
      }
    })

    this.currentSelection = filteredSelectedTransaction
  }

  onAddNewTransactionDialogClose () {
    this.showAddNewTransactionDialog = false
  }

  onCompleteTransaction (newTransaction: BankTransaction): void {
    this.importedTransactions = [newTransaction.transaction.id]
    this.onAddNewTransactionDialogClose()
    this.fetchData()
  }



  beforeMount() {
    this.gridOptions = {
      rowSelection: 'multiple',
      rowDeselection: true,
      rowMultiSelectWithClick: false,
      suppressContextMenu: true,
      cellFlashDelay: 3000,

      defaultColDef: {
        sortable: true,
        enableCellChangeFlash: true,

        filter: 'agTextColumnFilter',

        filterParams: {
          debounceMs: 250,
          textFormatter: (value: string) => value.toString().normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .toLowerCase()
        },

        floatingFilter: true,
        floatingFilterComponentParams: {
          suppressFilterButton: true
        }

      },
      onModelUpdated: (params: any) => {
        const dataset = params.api.rowModel.rowsToDisplay.map((r: RowNode) => r.data)

        setTimeout(() => {
          params.api.setPinnedBottomRowData(this.calculatePinnedRowData(dataset))
        }, 0)
      },

      statusBar: {
        statusPanels: [
          { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left' },
          { statusPanelFramework: 'BankTransactionCustomStatusPanel', align: 'left'}
        ],
      },

      overlayLoadingTemplate:
          `<div class="ag-overlay-loading-center" style="font-size: 15px">
         <i class="fas fa-spinner fa-pulse"></i>
         <span style="padding-left: 10px"> ${ this.$t('bankTransactionPage.loadingGridDataText') } </span>
     </div>`,

      getRowClass(params: RowNode): string {
        return ''//params.data.status.name === 'inactive' ? 'row-inactive' : ''
      },
      onFirstDataRendered (params: any) {
        params.api.sizeColumnsToFit()
      }
    }

    this.columnDefs = this.createColDefs()
  }

  onFlashRows(indexList: number[]) {
    this.gridOptions.api?.ensureIndexVisible(indexList[0])
    let rowNode: any[] = []
    indexList.forEach((item: number) => {
      rowNode.push(this.gridApi!.getDisplayedRowAtIndex(item))
    })
    this.gridApi?.flashCells({
      rowNodes: rowNode,
    });
  }

  calculatePinnedRowData(dataset: BankTransaction[]): any[] {
    let totalAmount = 0

    dataset.forEach(i => {
      totalAmount += i.transaction.amount
    })

    return [{
      transaction: {
        status: '',
        createdAt: '',
        boarder: '',
        amount: totalAmount,
        variableSymbol:'',
        specificSymbol: '',
        fromIban: '',
        name:'',
      }
    }];
  }

  closeDetailDialog(){
    this.showTransactionDetailDialog = false
    this.transactionDetail = null
  }

  onDetailTransaction (item: any) {
    this.transactionDetail = item.data
    this.showTransactionDetailDialog = true
  }

  async fetchData (payloadWithFilter?: BankTransactionListPayload | null): Promise<void> {
    this.$refs.form.resetValidation()
    this.gridOptions.api?.showLoadingOverlay()
    if (this.cancelToken) {
      this.cancelToken.cancel()
    }
    this.cancelToken = axios.CancelToken.source()
    let payload: BankTransactionListPayload = {
        dateBefore: this.dateBefore ? moment().toDate() : null,
        dateAfter: this.dateBefore ? this.dateBefore : null,
        status: null
      }
    let payloadWithCancelToken: BankTransactionListPayloadWithCancelToken = {
      payload: payloadWithFilter ? payloadWithFilter : payload,
      cancelToken: this.cancelToken
    }

    try {
      this.fetchInProgress = true
      this.bankTransactionData = await this.fetchBankTransactionList(payloadWithCancelToken)

      this.rowData = this.bankTransactionData
      this.pinnedRowData = this.calculatePinnedRowData(this.bankTransactionData)
      if(this.isResolveFilterActive) {
        this.rowData = this.rowData.filter((item: BankTransaction) => item.transaction.status === 'not_processed')
      }
    } catch (e) {
      this.bankTransactionData = []
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('businessPage.fetchDataError').toString()
    } finally {
      this.fetchInProgress = false
      this.gridOptions.api?.hideOverlay()

    }
  }

  created () {
    this.localeTextFunc = (key: string, defaultValue: string) => {
      const tKey = `agGrid.${key}`
      const translated = this.$t(tKey)
      if(tKey === translated){
        return defaultValue
      } else {
        return translated
      }

    }
  }

  mounted() {
    this.selectedFilter = this.timeFiltersList[1]
    this.dateBefore = moment().subtract(1, 'weeks').toDate()
    this.fetchData()
  }


}

</script>

<style lang="stylus" scoped>
>>> .row-inactive
  background-color silver

>>> .ag-text-field-input
  height 25px

.transaction {
  font-size: 17px;
}

>>> .v-toolbar__content {
  padding 0
}

.date-picker {
  max-width: 180px;
}

.ag-theme-balham
  >>> .ag-cell-data-changed
    background-color yellow !important

</style>
